import { useEffect } from 'react';

export function useEnterKeyEvent(onKeyPressEnter: () => void) {
  return useEffect(() => {
    const listener = (event: { code: string; preventDefault: () => void; }) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        onKeyPressEnter();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [onKeyPressEnter]);
}
